module.exports = __webpack_public_path__ + "assets/img/Blackpurl-Landing-Page-w960.a2242c9b.jpg";